<template>
  <Section title="Join the team" v-observe-visibility="intObseverCfg" pad-h pad-t>
    <SectionSubTitle>We are hiring</SectionSubTitle>
    <div class="box" v-scroll-reveal>
      <a href="mailto:contact@orcalabs.no">Click here to contact us</a>
    </div>
  </Section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Career',

  data() {
    return {
      intObseverCfg: {
        callback: this.setTopic,
        intersection: {
          rootMargin: '-200px',
        },
      },
    };
  },

  computed: mapState(['isScrolling']),

  methods: {
    setTopic: function (isVisible) {
      if (isVisible && !this.isScrolling) {
        this.$router.push({ path: '#career', query: { scroll: false } });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e14759;
  height: 240px;
  color: white;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;

  a {
    background-color: transparent;
    color: white;
    outline: none;
    border: none;
    padding: 20px 40px;
    font-size: 40px;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
